import { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import OwlCarousel from "react-owl-carousel";
import { LoginImg1, LoginImg2, LoginImg3, logo } from "../../imagepath";
import AuthContext from "../../../context/AuthContext";
import PaymentPage from "../../payment/card";
import Swal from "sweetalert2";
import Loader from "../../common/loader";
import PricingServices from "../../../services/PricingServices";

const hasNumber = (value) => {
  return new RegExp(/[0-9]/).test(value);
};
const hasMixed = (value) => {
  return new RegExp(/[a-z]/).test(value) && new RegExp(/[A-Z]/).test(value);
};
const hasSpecial = (value) => {
  return new RegExp(/[!#@$%^&*)(+=._-]/).test(value);
};

const strengthColor = (count) => {
  if (count < 1) return "poor";
  if (count < 2) return "weak";
  if (count < 3) return "strong";
  if (count < 4) return "heavy";
};

const IndividualTeacherRegister = () => {

  const usStates = [
    { name: 'Alabama', abbr: 'AL' }, { name: 'Alaska', abbr: 'AK' }, { name: 'Arizona', abbr: 'AZ' },
    { name: 'Arkansas', abbr: 'AR' }, { name: 'California', abbr: 'CA' }, { name: 'Colorado', abbr: 'CO' },
    { name: 'Connecticut', abbr: 'CT' }, { name: 'Delaware', abbr: 'DE' }, { name: 'Florida', abbr: 'FL' },
    { name: 'Georgia', abbr: 'GA' }, { name: 'Hawaii', abbr: 'HI' }, { name: 'Idaho', abbr: 'ID' },
    { name: 'Illinois', abbr: 'IL' }, { name: 'Indiana', abbr: 'IN' }, { name: 'Iowa', abbr: 'IA' },
    { name: 'Kansas', abbr: 'KS' }, { name: 'Kentucky', abbr: 'KY' }, { name: 'Louisiana', abbr: 'LA' },
    { name: 'Maine', abbr: 'ME' }, { name: 'Maryland', abbr: 'MD' }, { name: 'Massachusetts', abbr: 'MA' },
    { name: 'Michigan', abbr: 'MI' }, { name: 'Minnesota', abbr: 'MN' }, { name: 'Mississippi', abbr: 'MS' },
    { name: 'Missouri', abbr: 'MO' }, { name: 'Montana', abbr: 'MT' }, { name: 'Nebraska', abbr: 'NE' },
    { name: 'Nevada', abbr: 'NV' }, { name: 'New Hampshire', abbr: 'NH' }, { name: 'New Jersey', abbr: 'NJ' },
    { name: 'New Mexico', abbr: 'NM' }, { name: 'New York', abbr: 'NY' }, { name: 'North Carolina', abbr: 'NC' },
    { name: 'North Dakota', abbr: 'ND' }, { name: 'Ohio', abbr: 'OH' }, { name: 'Oklahoma', abbr: 'OK' },
    { name: 'Oregon', abbr: 'OR' }, { name: 'Pennsylvania', abbr: 'PA' }, { name: 'Rhode Island', abbr: 'RI' },
    { name: 'South Carolina', abbr: 'SC' }, { name: 'South Dakota', abbr: 'SD' }, { name: 'Tennessee', abbr: 'TN' },
    { name: 'Texas', abbr: 'TX' }, { name: 'Utah', abbr: 'UT' }, { name: 'Vermont', abbr: 'VT' },
    { name: 'Virginia', abbr: 'VA' }, { name: 'Washington', abbr: 'WA' }, { name: 'West Virginia', abbr: 'WV' },
    { name: 'Wisconsin', abbr: 'WI' }, { name: 'Wyoming', abbr: 'WY' },
    { name: 'District of Columbia', abbr: 'DC' }
  ];

  const navigate = useNavigate();
  const [eye, seteye] = useState(true);
  const [password, setPassword] = useState("");
  const [validationError, setValidationError] = useState("");
  const [strength, setStrength] = useState("");
  const [type, setType] = useState("Individual");
  const [reemcode, setReemCode] = useState(null);
  const [city, setCity] = useState("");
  const [zipCode, setZipCode] = useState("");
  const [stateName, setStateName] = useState("");

  const [discountName, setDiscountName] = useState("");
  const [discountDate, setDiscountDate] = useState(null);
  const [discountEmail, setDiscountEmail] = useState("");
  // const [pwdError, setPwdError] = useState("Use 8 or more characters with a mix of letters, numbers & symbols.")

  const onEyeClick = () => {
    seteye(!eye);
  };

  const handlePasswordChange = (event) => {
    const newPassword = event.target.value;
    setPassword(newPassword);
    validatePassword(newPassword);
  };

  const validatePassword = (value) => {
    if (!value) {
      setValidationError(1);
    } else if (value.length < 8) {
      setValidationError(2);
    } else if (!/[0-9]/.test(value)) {
      setValidationError(3);
    } else if (!/[!@#$%^&*()]/.test(value)) {
      setValidationError(4);
    } else {
      setValidationError(5);
    }
  };

  const messages = () => {
    if (validationError == 1) {
      return "";
    } else if (validationError == 2) {
      return (
        <span
          id="poor"
          className="active"
          style={{ fontSize: 12, color: "#DC3545" }}
        >
          😠 Weak. Must contain at least 8 characters
        </span>
      );
    } else if (validationError == 3) {
      return (
        <span
          id="weak"
          className="active"
          style={{ fontSize: 12, color: "#FFC107" }}
        >
          😲 Average. Must contain at least 1 letter or number
        </span>
      );
    } else if (validationError == 4) {
      return (
        <span
          id="strong"
          className="active"
          style={{ fontSize: 12, color: "#0D6EFD" }}
        >
          🙂 Almost. Must contain special symbol
        </span>
      );
    } else if (validationError == 5) {
      return (
        <span
          id="heavy"
          className="active"
          style={{ fontSize: 12, color: "#4BB543" }}
        >
          😊 Awesome! You have a secure password.
        </span>
      );
    }
  };

  const strengthIndicator = (value) => {
    let strengths = 0;

    if (value.length >= 8) strengths = 1;
    if (hasNumber(value) && value.length >= 8) strengths = 2;
    if (hasSpecial(value) && value.length >= 8 && hasNumber(value))
      strengths = 3;
    if (
      hasMixed(value) &&
      hasSpecial(value) &&
      value.length >= 8 &&
      hasNumber(value)
    )
      strengths = 3;
    return strengths;
  };

  var settings = {
    items: 2,
    margin: 25,
    dots: true,
    nav: true,
    navText: [
      '<i className="fas fa-arrow-left"></i>',
      '<i className="fas fa-arrow-right"></i>',
    ],

    loop: true,
    responsiveClass: true,
    responsive: {
      0: {
        items: 1,
      },
      768: {
        items: 1,
      },
      1170: {
        items: 1,
      },
    },
  };

  useEffect(() => {
    if (password !== "") {
      const strength = strengthIndicator(password);
      const color = strengthColor(strength);
      setStrength(color);
    } else {
      setStrength("");
    }
  }, [password]);

  // Extract promo code from URL on mount
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const reemCode = params.get("reemcode") || params.get("promo");
    if (reemCode) {
      setReemCode(reemCode);
    }
  }, []);

  ///////////
  const { registerUser } = useContext(AuthContext);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [address, setAddress] = useState("");

  const [showPayment, setShowPayment] = useState(false);
  const [Paymentamount, setPaymentamount] = useState(900);
  const [stateid, setStateid] = useState("");
  const [loading, setLoading] = useState(false);

  // Fetch pricing from backend on component mount and when promo code changes
  useEffect(() => {
    const fetchPricing = async () => {
      try {
        // Check for promo code in URL
        const discountUrl = new URLSearchParams(window.location.search);
        const urlPromoCode = discountUrl.get("reemcode") || discountUrl.get("promo");
        const promoCodeToUse = reemcode || urlPromoCode;
        const isFromUrl = !!urlPromoCode;

        const pricing = await PricingServices.getPricing('teacher', promoCodeToUse, isFromUrl);
        if (pricing && pricing.amount) {
          setPaymentamount(parseFloat(pricing.amount));

          // If promo code is valid, update reemcode state
          if (pricing.promoCode && !reemcode) {
            setReemCode(pricing.promoCode);
          }
        }
      } catch (error) {
        console.error("Error fetching teacher pricing:", error);
        // Keep default value of 500 if fetch fails
      }
    };
    fetchPricing();
  }, [reemcode]); // Re-fetch when promo code changes

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    const userdetails = {
      name,
      email,
      password,
      type_id: "teacher",
      stateid,
      address: address + ", " + city + ", " + stateName + ", " + zipCode
    };
    try {
      // await registerUser(userdetails);
      const response = await registerUser(userdetails);
      setLoading(false);
      Swal.fire({
        title: "Success!",
        text: "Teacher Registration successful !",
        icon: "success",
        confirmButtonText: "OK",
      });
      // alert('School Registration successful. Please login.');
      // Use response.amount if available, otherwise keep the fetched price
      const finalAmount = response.amount && parseFloat(response.amount) > 0
        ? parseFloat(response.amount)
        : Paymentamount; // Fallback to the price we fetched earlier
      console.log("Registration response:", response);
      console.log("Setting payment amount:", finalAmount);
      setPaymentamount(finalAmount);
      setShowPayment(true);

      // switch (response.role) {
      //   case 1:
      //       navigate('/card');
      //       break;

      // }
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  };
  const slides = [
    {
      image: LoginImg1,
      title: "Welcome to ",
      subtitle: " AngelWatchLMS Courses",
      content: `The AngelWatch National Certification Program is the first
      and only emergency training system of its kind—specifically designed to prepare teachers, school
      staff, and childcare providers to respond instantly and effectively in real-world crisis situations. Developed
      after 9/11 and previously used to protect U.S. government facilities around the world, this elite training is now
      available for civilian application for the very first time.
      <br /><strong>AngelWatch is:</strong><br />
      Partnered with the American Red Cross and the American Heart Association, and backed by the Department of Homeland Security — built in collaboration with the Department of Defense and the Department of Emergency Management.`
    },
    {
      image: LoginImg2,
      title: "Welcome to ",
      subtitle: " AngelWatchLMS Courses",
      content: `Legal Notice: All training content, techniques, software
      systems, and hardware demonstrated within the AngelWatch Certification Program are copyrighted, trademarked, and
      patented in the United States. This intellectual property is the exclusive legal property of AngelWatch and is
      protected by federal law. Unauthorized use, reproduction, adaptation, or the creation of derivative courses or
      materials based on this program is strictly prohibited and will result in legal action. Any individual or
      organization found attempting to mimic, copy, or alter any aspect of the AngelWatch training system will be held
      accountable to the fullest extent of the law. We maintain strict protection of this content to ensure that the
      quality, accuracy, and life-saving integrity of our training is never compromised or "dumbed down." This is
      critical to ensuring the safety of your staff, teachers, and the children in your care.`
    },
    {
      image: LoginImg3,
      title: "Welcome to ",
      subtitle: " AngelWatchLMS Courses",
      content: `It is fully online, available on-demand 24/7, and provides
      12 months of unlimited access for your entire staff—making it ideal for initial training, new hires, and
      recertification without disrupting your operations. Each center also receives a FREE Emergency Management Protocol
      Handbook, making you instantly compliant with state-mandated emergency planning—with no extra work. This
      course is so unique and valuable, it is copyrighted, trademarked, and patented in the United States. AngelWatch
      doesn't just teach policies. It trains instinct, builds confidence, and saves lives. Train now. Be ready. Stay
      alive. Due to the nature of this training and the sensitive security content involved, all AngelWatch
      Certification Program purchases are final. Because our course materials are designed to protect children, staff,
      and educational facilities—and include proprietary, copyrighted, and patented content—no refunds will be
      issued after enrollment. We appreciate your understanding and commitment to safety.`
    }
  ];
  return (
    <div className="main-wrapper log-wrap">
      <Loader loading={loading} />
      {!showPayment ? (
        <div className="row">
          {/* Login Banner */}
          <div className="col-md-6 login-bg">
            <div id="loginCarousel" className="carousel slide" data-bs-ride="carousel">
              <div className="carousel-inner">
                {slides.map((slide, index) => (
                  <div className={`carousel-item ${index === 0 ? 'active' : ''}`} key={index}>
                    <div className="welcome-login">
                      <div className="login-banner">
                        <img src={slide.image} className="d-block w-100" alt={`Slide ${index + 1}`} />
                      </div>
                      <div className="mentor-course text-center">
                        <h2 style={{ fontFamily: "Fredoka" }}>
                          {slide.title}
                        </h2>
                        <h1 style={{ fontFamily: "Fredoka", color: "white", fontWeight: "bold" }}>
                          {slide.subtitle}
                        </h1>
                        <p
                          style={{ fontFamily: "Poppins" }}
                          dangerouslySetInnerHTML={{ __html: slide.content }}
                        />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <button
                className="carousel-control-prev"
                type="button"
                data-bs-target="#loginCarousel"
                data-bs-slide="prev"
              >
                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                {/* <span className="visually-hidden">Previous</span> */}
              </button>
              <button
                className="carousel-control-next"
                type="button"
                data-bs-target="#loginCarousel"
                data-bs-slide="next"
              >
                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Next</span>
              </button>
            </div>
          </div>
          {/* /Login Banner */}
          <div className="col-md-6 login-wrap-bg">
            {/* Login */}
            <div className="login-wrapper">
              <div className="loginbox">
                <div className="img-logo">
                  <img src={logo} className="img-fluid" alt="Logo" />
                  <div className="back-home">
                    <Link to={process.env.REACT_APP_URL || "/"}>Back to Home</Link>
                  </div>
                </div>
                <h1>Sign up</h1>
                <form onSubmit={handleSubmit}>
                  <div className="input-block">
                    <label className="form-control-label">Name</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter the Name"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      required
                    />
                  </div>
                  <div className="input-block">
                    <label className="form-control-label">Email</label>
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Enter your email address"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </div>
                  <div className="input-block">
                    <label className="form-control-label">Address</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter your address"
                      value={address}
                      onChange={(e) => setAddress(e.target.value)}
                      required
                    />
                  </div>
                  <div className="input-block">
                    <label className="form-control-label">City</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter your City"
                      required
                      value={city}
                      onChange={(e) => {
                        setCity(e.target.value);
                      }}
                    />
                  </div>
                  <div className="input-block">
                    <label className="form-control-label">State</label>
                    <select
                      className="form-control"
                      value={stateName}
                      onChange={(e) => setStateName(e.target.value)}
                      required
                    >
                      <option value="">Select State</option>
                      {usStates.map((state) => (
                        <option key={state.abbr} value={state.abbr}>
                          {state.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="input-block">
                    <label className="form-control-label">Zip Code</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter your Zip Code"
                      pattern="[0-9]{5}"
                      maxLength="5"
                      inputMode="numeric"
                      required
                      value={zipCode}
                      onChange={(e) => {
                        setZipCode(e.target.value);
                      }}
                    />
                  </div>
                  <div className="input-block">
                    <label className="form-control-label">
                      School License Number (if applicable)
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter the State School License Number"
                      value={stateid}
                      onChange={(e) => {
                        setStateid(e.target.value);
                      }}
                    />
                  </div>

                  <div className="input-block">
                    <label className="form-control-label">Password</label>
                    <div className="pass-group" id="passwordInput">
                      <input
                        className="form-control pass-input"
                        placeholder="Enter your password"
                        type={eye ? "password" : "text"}
                        onChange={handlePasswordChange}
                        value={password}
                      />
                      {/* <span onClick={onEyeClick} className={`fa toggle-password feather-eye" ${eye ? "fa-eye" : "fa-eye-slash" }`}/> */}
                      <span
                        onClick={onEyeClick}
                        className={`fa toggle-password feather-eye" ${eye ? "fa-eye" : "fa-eye-slash"
                          }`}
                      />
                      <span className="toggle-password feather-eye"></span>
                      <span className="pass-checked">
                        <i className="feather-check"></i>
                      </span>
                    </div>
                    <div
                      id="passwordStrength"
                      style={{ display: "flex" }}
                      className={`password-strength ${strength === "poor"
                        ? "poor-active"
                        : strength === "weak"
                          ? "avg-active"
                          : strength === "strong"
                            ? "strong-active"
                            : strength === "heavy"
                              ? "heavy-active"
                              : ""
                        }`}
                    >
                      <span id="poor" className="active"></span>
                      <span id="weak" className="active"></span>
                      <span id="strong" className="active"></span>
                      <span id="heavy" className="active"></span>
                    </div>
                    <div id="passwordInfo">{messages()}</div>
                  </div>

                  <div className="d-grid">
                    <button className="btn  btn-start" type="submit">
                      Create Account
                    </button>
                  </div>
                </form>
              </div>
              <div className="google-bg text-center">
                {/* <span>
                  <Link to="#">Or sign in with</Link>
                </span>
                <div className="sign-google">
                  <ul>
                    <li>
                      <Link to="#">
                        <img src={NetIcon1} className="img-fluid" alt="Logo" />
                        Sign In using Google
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        <img src={NetIcon2} className="img-fluid" alt="Logo" />
                        Sign In using Facebook
                      </Link>
                    </li>
                  </ul>
                </div> */}
                <p className="mb-0">
                  Already have an account? <Link to="/login">Sign in</Link>
                </p>
              </div>
            </div>
            {/* /Login */}
          </div>
        </div>
      ) : (
        <PaymentPage
          amount={Paymentamount}
          reemcode={reemcode}
          onSuccess={(response, selectedPlanType) => {
            console.log("Payment Successful", response, selectedPlanType);
            setShowPayment(false); // Hide payment page after success
          }}
        />
      )}
    </div>
  );
};

export default IndividualTeacherRegister;
